import React from 'react';
import classnames from 'classnames';
import slugify from 'slugify';
import { Link } from 'gatsby';
import { useIntl } from 'react-intl';
import { X } from 'react-feather';
import path from 'path-browserify';
// import { addTrailingSlash } from '../../lib/helpers';

import Map from '../Map';
import StrapiButton from '../StrapiLink/StrapiButton';
import { SchoolCardFragment } from '../../../graphql.schema';
import { addTrailingSlash } from '../../lib/helpers';

import * as styles from './SchoolLocationCard.module.scss';

type SchoolLocationCardProps = SchoolCardFragment & {
  certificationName?: string;
  selectedTags?: string[];
  schoolSlugBase: string;
  isMapCard?: boolean;
  onClose?: () => void;
  mapLocation?: { latitude?: number, longitude?: number }
};

const SchoolLocationCard = ({
  name,
  address,
  phoneNumber,
  schoolSlugBase,
  slug,
  isMapCard,
  mapLocation,
  onClose,
}: SchoolLocationCardProps) => {
  const intl = useIntl();
  return (
    <div
      data-testid="school-location"
      className={classnames(
        styles.schoolLocationCardWrapper,
        styles.schoolLocationCard,
        isMapCard ? styles.positionModuleUser : '',
      )}
    >
      <div className="columns school-location-card is-flex">
        <div className="column is-8 is-6-mobile p-0">
          <Map
            markers={[
              {
                id: '1',
                lat: mapLocation?.latitude || 0,
                lng: mapLocation?.longitude || 0,
                popUpHtml: '',
              },
            ]}
            width="100%"
            height="100%"
            defaultZoom={13}
            mapOptions={{
              zoomControl: false,
              gestureHandling: 'none',
              scrollwheel: false,
              streetViewControl: false,
              fullscreenControl: false,
              mapTypeControl: false,
              scaleControl: false,
              panControl: false,
              rotateControl: false,
              clickableIcons: false,
            }}
          />
        </div>
        <div className={classnames(styles.infoWrapper, 'column is-4 is-6-mobile')}>
          <div className={styles.meta}>
            <div itemScope itemType="https://schema.org/EducationalOrganization">
              <div className="is-flex is-justify-content-space-between">
                <Link to={addTrailingSlash(path.join(schoolSlugBase, slug ?? slugify(name, { lower: true, strict: true })))} data-testid='mocktestLinkcomponent'>
                  <h4 itemProp="name" className="brand-a is-4 title mb-4">
                    {name}
                  </h4>
                </Link>
                {isMapCard ? <X data-testid='close-icon' onClick={onClose} className="black-3 ml-1 has-text-weight-bold" size={20} /> : <></>}
              </div>
              <div itemProp="address" className="pb-2">
                <Link to={addTrailingSlash(path.join(schoolSlugBase, slug ?? slugify(name, { lower: true, strict: true })))} data-testid='mockaddressLink'>
                  <p className="is-text-2 black-2">{address?.streetAddress}</p>
                  {address?.locality ? (
                    <p className="is-text-2 black-2">{[address?.locality, address?.postalCode].join(', ')}</p>
                  ) : null}
                </Link>
              </div>
              {phoneNumber ? (
                <p className="is-text-2 black-2" itemProp="telephone" data-testid='telephone'>
                  <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
                </p>
              ) : null}
              <StrapiButton
                openInNewWindow={false}
                id={'school-location-card'}
                title={intl.formatMessage({ id: 'visit-school', defaultMessage: 'Visit School' })}
                className={classnames(styles.visitSchoolLink, 'is-secondary button')}
                url={path.join(schoolSlugBase, slug ?? slugify(name, { lower: true, strict: true }))}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchoolLocationCard;
